module.exports = __webpack_public_path__ + "media/images/ui__infoBox--dark-76adf758a6e9380b8de17fe7b55b468d.png";